import React, { useRef, useState, useReducer, useEffect } from 'react'
import mapboxgl from 'mapbox-gl/dist/mapbox-gl-csp'
import { useForm, Controller } from 'react-hook-form'
// eslint-disable-next-line import/no-webpack-loader-syntax
import MapboxWorker from 'worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Button from '@material-ui/core/Button'
import CloseIcon from '@material-ui/icons/Close'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import EqualizerIcon from '@material-ui/icons/Equalizer'
import Fab from '@material-ui/core/Fab'
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord'
import InfoIcon from '@material-ui/icons/Info'
import IconButton from '@material-ui/core/IconButton'
import MenuItem from '@material-ui/core/MenuItem'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TextField from '@material-ui/core/TextField'
import Paper from '@material-ui/core/Paper'
import Popover from '@material-ui/core/Popover'
import SaveIcon from '@material-ui/icons/Save'

import MapView from './components/map'
import FilterPanel from './components/filterPanel'
import Statistics from '../common/statistics'
import AlertWrapper from '../common/alert'
import { MAPBOX_API_KEY } from '../../constants/mapbox'
import { get, post } from '../../config/fetch'
import { getKpiColorByNetworkIndicator, infoIndicators } from './kpiUtils'
import { TOKEN_GET_BASE_STATION, TOKEN_GET_DEVICES_LIST, TOKEN_GET_KPIS, TOKEN_REPORT } from '../../constants/constants'
import { useLocation } from 'react-router-dom'

mapboxgl.workerClass = MapboxWorker
mapboxgl.accessToken = MAPBOX_API_KEY

const useStyles = makeStyles(theme => ({
    mapWrapper: {
        width: '100%',
        height: 'calc(100% - 64px)',
        position: 'relative',
    },
    'MuiFormControl-root': {
        width: '100%',
    },
    accordionDetails: {
        width: '100%',
    },
    accordionKpiLegend: {
        backgroundColor: 'rgba(66,66,66,.5)',
    },
    wrapperLoader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
}))

const StyledTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell)

const StyledTableRow = withStyles(theme => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow)

const networkIndicators = {
    LTE: [
        { label: 'RSRP (dBm)', value: 'RSRP' },
        { label: 'RSRQ (dB)', value: 'RSRQ' },
        { label: 'RSSNR', value: 'RSSNR' },
    ],
    WCDMA: [
        { label: 'RSCP', value: 'RSCP' },
        { label: 'Ec/Io (dB)', value: 'Ec/Io' },
    ],
}

function Heatmap() {
    const today = new Date()
    const classes = useStyles()

    const { handleSubmit, control, reset } = useForm()
    const [state, setState] = useReducer((s, a) => ({ ...s, ...a }), {
        lng: -99.1332,
        lat: 19.4326,
        zoom: 11,
        loaded: false,
        devicesList: [],
    })

    const [stateReport, setStateReport] = useReducer((s, a) => ({ ...s, ...a }), {
        error: null,
        loading: false,
        message: null,
        resolved: false,
        typeMessage: null,
        visibleMessage: false,
    })

    const location = useLocation()
    const search = useLocation().search;
    const lng = new URLSearchParams(search).get('lng');
    const lat = new URLSearchParams(search).get('lat');
    const pStartDate = new URLSearchParams(search).get('startDate');
    const pEndDate = new URLSearchParams(search).get('endDate');
    
    const [anchorPopoverKpi, setAnchorPopoverKpi] = useState(null)
    const [baseStations, setBaseStations] = useState([])
    const [endDate, setEndDate] = useState(new Date())
    const [map, setMap] = useState(null)
    const mapContainer = useRef()
    const [networkType, setNetworkType] = useState('')
    const [deviceList, setDeviceList] = useState('')
    const [networkIndicator, setNetworkIndicator] = useState('')
    const [rangeKpi, setRangeKpi] = useState(4)
    const [showConnections, setShowConnections] = useState(false)
    // the ref is to keep the state of switch (Show connections) up to date
    const showConnectionsRef = useRef(false)
    const [startDate, setStartDate] = useState(
        new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0),
    )
    const [report, setReport] = useState({
        url: null,
        kpis: [],
    })
    const [visiblePopover, setVisiblePopover] = useState(true)
    const [visibleDialogReport, setVisibleDialogReport] = useState(false)
    const [visibleStatisticsModal, setVisibleStatisticsModal] = useState(false)
    const [loadNetwork, setLoadNetwork] = useState(false)
    const [initParam, setInitParam] = useState({
        lng: 0,
        lat: 0,
        startDate: new Date(),
        endDate: new Date()
    })

    useEffect(() => {
        fetchDevicesList()
            .then(dl => {
                setState({ ...state, devicesList: dl, loaded: true })
            })
            .catch(e => {
                setState({ ...state, loaded: true })
            })
    }, [])

    useEffect(() => {
        console.log('lng: ', lng)
        console.log('lat: ', lat)
        console.log('pStartDate: ', pStartDate)
        console.log('pEndDate: ', pEndDate)

        if (lng && lat && pStartDate && pEndDate) {
            const startD = new Date(pStartDate)
            const endD = new Date(pEndDate)
            setStartDate(startD)
            setEndDate(endD)

            console.log('startD: ', startD)
            console.log('endD: ', endD)

            setLoadNetwork(true)
            setInitParam({
                lng: lng,
                lat: lat,
                startDate: startD,
                endDate: endD
            })
            //setState({ ...state, lng: lng, lat: lat })
            console.log('initParam: ', initParam)
            console.log('state: ', state)
        }
    }, [])
    
    const fetchBaseStations = async (
        lng,
        lat,
        radius
    ) => {
        try {
            const radiusInKm = Number(radius) * 1000
            /*
            const { data: baseStations } = await get(
                `/baseStations?bounds=${bounds}&networkType=${networkType}&code=w1tizlnVOuxMTTZagTSobrdHBcrUs62NaG3WaYMPaze1KMzw7Fsh1w%3D%3D`,
            )
            */
            const { data: baseStations } = await get(
                `/baseStations?lng=${lng}&lat=${lat}&radius=${radiusInKm}&networkType=${networkType}&code=${TOKEN_GET_BASE_STATION}`,
            )

            return baseStations
        } catch (e) {
            throw new Error(e)
        }
    }

    const fetchDevicesList = async () => {
        try {
            const { data: devicesList } = await get(
                `/devicesList?code=${TOKEN_GET_DEVICES_LIST}`,
            )

            return devicesList
        } catch (e) {
            throw new Error(e)
        }
    }

    const fetchKpis = async (
        lng,
        lat,
        radius,
        startDate = '',
        endDate = '',
        devicesListId = '',
    ) => {
        try {
            const radiusInKm = Number(radius) * 1000
            const startDateISO = new Date(startDate).toISOString()
            const endDateISO = new Date(endDate).toISOString()
            const url = `/kpis?code=${TOKEN_GET_KPIS}&lng=${lng}&lat=${lat}&radius=${radiusInKm}&startDate=${startDateISO}&endDate=${endDateISO}&networkType=${
                networkType || ''
            }&devicesListId=${devicesListId || ''}`

            /*const url = `/kpis?code=2vCp973PNX/f1YkIxT3CAY5FA277IoDC5bBJKBVRUlMMndoL6IHXLQ==&lng=${lng}&lat=${lat}&radius=${radiusInKm}&startDate=${startDateISO}&endDate=${endDateISO}&networkType=${
                networkType || ''
            }&devicesListId=${devicesListId || ''}`*/

            const { data: kpis } = await get(url)

            if (kpis.length > 0) {
                setReport({ url, kpis })
            } else {
                setReport({ url: null, kpis })
            }

            return kpis
        } catch (e) {
            throw new Error(e)
        }
    }

    const getMapBounds = map => {
        const ne = map.getBounds().getNorthEast()
        const coordsNe = JSON.stringify([ne.lng, ne.lat])
        const nw = map.getBounds().getNorthWest()
        const coordsNw = JSON.stringify([nw.lng, nw.lat])
        const se = map.getBounds().getSouthEast()
        const coordsSe = JSON.stringify([se.lng, se.lat])
        const sw = map.getBounds().getSouthWest()
        const coordsSw = JSON.stringify([sw.lng, sw.lat])
        const bounds = `[${coordsNw},${coordsNe},${coordsSe},${coordsSw},${coordsNw}]`

        return bounds
    }

    const handleChangeSlider = (event, newValue) => {
        setRangeKpi(Number(newValue))
    }

    const handleDate = date => {
        setStartDate(date)
        const newEndDate = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            endDate.getHours(),
            endDate.getMinutes(),
        )
        setEndDate(newEndDate)
    }

    const handleStartTime = date => {
        setStartDate(date)
    }

    const handleEndTime = date => {
        setEndDate(date)
    }

    const handleChangeAccordion = () => {
        setVisiblePopover(!visiblePopover)
    }

    const handleChangeNetworkType = e => {
        setNetworkType(e.target.value)
    }

    const handleChangeNetworkIndicator = e => {
        setNetworkIndicator(e.target.value)
    }

    const handleChangeDevicesList = e => {
        setDeviceList(e.target.value)
    }

    const handleClick = event => {
        setAnchorPopoverKpi(event.currentTarget)
    }

    const handleClosePopover = () => {
        setAnchorPopoverKpi(null)
    }

    const handleCloseDialogReport = () => {
        setVisibleDialogReport(false)
        reset()
    }

    const handleCloseMessageReport = () => {
        setStateReport({
            ...stateReport,
            visibleMessage: false,
        })
    }

    const handleSwitchConnections = e => {
        showConnectionsRef.current = e.target.checked
        setShowConnections(e.target.checked)
    }

    const handleFilter = () => {
        // set new map with new parameters (range kpi, start date, end date)
        const newMap = new mapboxgl.Map({
            container: mapContainer.current,
            style: 'mapbox://styles/mapbox/dark-v9',
            center: [state.lng, state.lat],
            zoom: state.zoom,
        })
        newMap.on('load', async () => {
            setMap(newMap)
            // OCTO-5
            // const bounds = getMapBounds(map)
            // const newBaseStations = await fetchBaseStations(bounds)
            // setBaseStations(newBaseStations)
        })
    }

    const cleanFilter = () => {
        setRangeKpi(4)
        setStartDate(new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0))
        setEndDate(new Date())
        setNetworkType('')
    }

    const renderNetworkIndicator = networkType => {
        if (networkType && networkType !== '') {
            return networkIndicators[networkType].map((item, index) => (
                <MenuItem key={`menuItem-${index}`} value={item.value}>
                    {item.label}
                </MenuItem>
            ))
        } else {
            return null
        }
    }

    const renderTableHead = networkType => {
        if (networkType && networkType !== '') {
            return networkIndicators[networkType].map((item, index) => (
                <StyledTableCell key={`tableHead-${index}`} align="center">
                    {item.label}
                </StyledTableCell>
            ))
        } else {
            return null
        }
    }

    const renderTableRow = obj => {
        let row = []

        Object.keys(obj).map((item, index) => {
            if (index === 0) {
                row.push(
                    <StyledTableCell key={`tableRow-${index}`} component="th" scope="row">
                        <FiberManualRecordIcon htmlColor={obj[item]} />
                    </StyledTableCell>,
                )
            } else {
                row.push(
                    <StyledTableCell key={`tableRow-${index}`} align="center">
                        {obj[item]}
                    </StyledTableCell>,
                )
            }
        })

        return row
    }

    const saveReport = async data => {
        const url = report.url
        const newReport = {
            ...data,
            url,
            networkType,
            networkIndicator,
        }

        setStateReport({
            ...stateReport,
            loading: true,
        })
        try {
            const { data } = await post(
                '/reports?code=' + TOKEN_REPORT,
                newReport,
            )
            setStateReport({
                ...stateReport,
                loading: false,
                resolved: true,
                visibleMessage: true,
                typeMessage: 'success',
                message: `Report ${data.name} has been saved successfuly.`,
            })
            setVisibleDialogReport(false)
        } catch (e) {
            setStateReport({
                ...stateReport,
                loading: false,
                error: e,
                visibleMessage: true,
                typeMessage: 'error',
                message: `An error has ocurred. Please, try again.`,
            })
            setVisibleDialogReport(false)
            throw new Error(e)
        }
    }

    const valueSlider = value => {
        return `${value} km`
    }

    const openPopoverKpiLegend = Boolean(anchorPopoverKpi)
    const idPopoverKpiLegend = openPopoverKpiLegend ? 'popover-kpi-legend' : undefined

    return (
        <div className={classes.mapWrapper}>
            {state.loaded && (
                <MapView
                    deviceList={deviceList}
                    baseStations={baseStations}
                    endDate={endDate}
                    map={map}
                    mapContainer={mapContainer}
                    rangeKpi={rangeKpi}
                    showConnections={showConnections}
                    showConnectionsRef={showConnectionsRef}
                    startDate={startDate}
                    state={state}
                    fetchKpis={fetchKpis}
                    fetchBaseStations={fetchBaseStations}
                    getMapBounds={getMapBounds}
                    networkIndicator={networkIndicator}
                    setBaseStations={setBaseStations}
                    setMap={setMap}
                    setState={setState}
                    loadNetwork={loadNetwork}
                    initParam={initParam}
                />
            )}
            {networkType && (
                <div style={{ position: 'absolute', right: 25, top: 20 }}>
                    <Fab
                        color="default"
                        aria-describedby={idPopoverKpiLegend}
                        variant="round"
                        onClick={handleClick}
                        size="small"
                    >
                        <InfoIcon />
                    </Fab>
                    <Popover
                        id={idPopoverKpiLegend}
                        open={openPopoverKpiLegend}
                        anchorEl={anchorPopoverKpi}
                        onClose={handleClosePopover}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                    >
                        {networkType ? (
                            <TableContainer component={Paper}>
                                <Table className={classes.table} aria-label="customized table">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>{networkType}</StyledTableCell>
                                            {renderTableHead(networkType)}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {infoIndicators[networkType].map(row => (
                                            <StyledTableRow key={row.name}>
                                                {renderTableRow(row)}
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        ) : (
                            <p style={{ padding: '1em' }}>
                                Select network type to show table legend
                            </p>
                        )}
                    </Popover>
                </div>
            )}
            {report.kpis.length > 0 && networkType && (
                <div
                    style={{
                        position: 'absolute',
                        bottom: 30,
                        right: 20,
                    }}
                >
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {networkIndicator && (
                            <Fab
                                color="default"
                                variant="round"
                                size="small"
                                onClick={() => setVisibleStatisticsModal(true)}
                            >
                                <EqualizerIcon />
                            </Fab>
                        )}

                        <Fab
                            color="default"
                            variant="round"
                            size="small"
                            style={{ margin: '1em 0' }}
                            onClick={() => setVisibleDialogReport(true)}
                        >
                            <SaveIcon />
                        </Fab>
                    </div>
                </div>
            )}
            <FilterPanel
                classes={classes}
                deviceList={deviceList}
                devicesList={state.devicesList}
                expanded={visiblePopover}
                endDate={endDate}
                startDate={startDate}
                networkType={networkType}
                networkIndicator={networkIndicator}
                rangeKpi={rangeKpi}
                showConnections={showConnections}
                cleanFilter={cleanFilter}
                handleFilter={handleFilter}
                handleDate={handleDate}
                handleStartTime={handleStartTime}
                handleEndTime={handleEndTime}
                valueSlider={valueSlider}
                handleChangeSlider={handleChangeSlider}
                handleChangeAccordion={handleChangeAccordion}
                handleChangeDevicesList={handleChangeDevicesList}
                handleChangeNetworkType={handleChangeNetworkType}
                handleChangeNetworkIndicator={handleChangeNetworkIndicator}
                handleSwitchConnections={handleSwitchConnections}
                renderNetworkIndicator={renderNetworkIndicator}
            />
            <DialogReport
                classes={classes}
                control={control}
                handleCloseDialogReport={handleCloseDialogReport}
                handleSubmit={handleSubmit}
                loadingReport={stateReport.loading}
                saveReport={saveReport}
                visibleDialogReport={visibleDialogReport}
            />
            <AlertWrapper
                description={stateReport.message}
                handleClose={handleCloseMessageReport}
                type={stateReport.typeMessage}
                visible={stateReport.visibleMessage}
            />

            {visibleStatisticsModal && (
                <Paper
                    elevation={3}
                    style={{
                        position: 'absolute',
                        left: '350px',
                        top: '10%',
                        width: 'calc(100% - 400px)',
                        padding: '1em',
                        height: 'auto',
                        maxHeight: '80vh',
                        overflowY: 'auto',
                        background: 'rgba(1,1,1,0.8)',
                    }}
                >
                    <div
                        className="header-graphucs"
                        style={{ width: '100%', height: '4em', borderBottom: '1px solid #ccc' }}
                    >
                        <div>
                            <h1 style={{ margin: 0, textAlign: 'center' }}>Graphics</h1>
                        </div>
                    </div>
                    <div style={{ position: 'absolute', top: 10, right: 10, zIndex: 3 }}>
                        <IconButton
                            aria-label="close"
                            color="default"
                            variant="contained"
                            type="button"
                            onClick={() => setVisibleStatisticsModal(false)}
                        >
                            <CloseIcon />
                        </IconButton>
                    </div>
                    <div style={{ margin: '1em 0' }}>
                        <Statistics
                            kpis={report.kpis}
                            networkIndicator={networkIndicator}
                            networkType={networkType}
                        />
                    </div>
                </Paper>
            )}
        </div>
    )
}

function DialogReport(props) {
    const {
        classes,
        control,
        handleCloseDialogReport,
        handleSubmit,
        loadingReport,
        saveReport,
        visibleDialogReport,
    } = props
    return (
        <Dialog
            open={visibleDialogReport}
            onClose={handleCloseDialogReport}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title">Save Report</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    To save this report, please enter name and description here.
                </DialogContentText>
                {loadingReport ? (
                    <div className={classes.wrapperLoader}>
                        <CircularProgress />
                    </div>
                ) : (
                    <form onSubmit={handleSubmit(saveReport)}>
                        <Controller
                            name="name"
                            control={control}
                            rules={{ required: true }}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    autoFocus
                                    margin="dense"
                                    label="Name"
                                    type="text"
                                    fullWidth
                                    required
                                    inputRef={field.ref}
                                    error={fieldState.invalid}
                                />
                            )}
                        />
                        <Controller
                            name="description"
                            control={control}
                            rules={{ required: true }}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    margin="dense"
                                    label="Description"
                                    type="text"
                                    required
                                    fullWidth
                                    inputRef={field.ref}
                                    error={fieldState.invalid}
                                />
                            )}
                        />
                    </form>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDialogReport} color="primary" disabled={loadingReport}>
                    Cancel
                </Button>
                <Button
                    onClick={handleSubmit(saveReport)}
                    color="primary"
                    type="submit"
                    disabled={loadingReport}
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default Heatmap
